// ##### Komarov 2025-07-22
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-22
const BookButtonHotelButton = ({ className, AddToBasket, available_now }) => {
  // ##### Komarov 2025-08-05
  const Book_Now = useLocalizedText('Book Now');
  const LeaveRequest = useLocalizedText('LeaveRequest');

  // ##### 24-03-21 Komarov
  return (
    <button
      type="button"
      className={className}
      onClick={AddToBasket}
      data-component="BookButtonHotelButton"
    >
      {
        // ##### 24-04-05 Komarov
        (!!available_now && Book_Now) || LeaveRequest
      }
    </button>
  );
};

export default BookButtonHotelButton;
